import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getContentData } from "../Utils/content";
import { appname } from "../Utils/constants";

const ImgComp = (props) => {

  const [imageBool, setImageBool] = useState(true);

  const storeSel = useSelector((state) => state);
  const appValue = storeSel.emailData?.appStatus;

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const appParam = searchParams.get('app');
 
  //   if(appParam)
  //   {
  //     if(appParam == "true") setImageBool(false);
  //     else setImageBool(true);
  //   }

  //   else setImageBool(true);
  // },[])

   if (appValue === true || appValue === "true") {
    return null; 
  }

  // if(!imageBool) return null;

  return (
    <>
      <div className="img-box">
        <img className="main-img" src={getContentData(props.appname).bannerImage} alt="" />
      </div>
    </>
  );
};

export default ImgComp;
